import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * When user tries to use an invite when invites are disabled
 */
export class InvitesDisabled extends NoticeBase
{
	constructor(portalName: string)
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_ADMIN_HAS_DISABLED_INVITES'),
			Loc.getMessage('EXT_B24NET_LOGGING_CANT_CONNECT', {
				'[b]': '<b>',
				'[/b]': '</b>',
				'[br]': '<br>',
				'#PORTAL_NAME#': portalName,
			}),
		);
	}
}
